import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { FormDataBillingFieldsComponent } from '../form-data-billing-fields/form-data-billing-fields.component';

@Component({
  selector: 'dhl-form-data-billing',
  templateUrl: './form-data-billing.component.html',
  styleUrls: ['./form-data-billing.component.scss']
})
export class FormDataBillingComponent implements OnInit {
  @Input() databilling: any;
  @Input() userCatalogs: any;

  @Output() hasBillingAddressEvent = new EventEmitter<boolean>();

  @ViewChild('formDataBillingFields') dataBiling!: FormDataBillingFieldsComponent;

  private readonly ASW_YES: string = 'Si';
  private readonly ASW_NO: string = 'No';

  showDatafacturingAdd: boolean = false;
  defaultPreference: string = this.ASW_NO;

  getActualDataFact: boolean = true;
  showDataFact: boolean = false;
  selectedBAOption: string = '';

  constructor(public router: Router, public snackBar: MatSnackBar) {}

  ngOnInit(): void {
    this.getActualDataFact = true;
    if (!this.databilling || Object.keys(this.databilling).length === 0) {
      this.openSnackbar();
    } else {
      this.hasBillingAddressEvent.emit(true);
      this.selectedBAOption = 'actual';
    }
  }

  validShowDatafact(isShowFormFacturingAdd: boolean) {
    if (!isShowFormFacturingAdd) {
      this.getActualDataFact = false;
    }
    this.showDatafacturingAdd = isShowFormFacturingAdd;
  }

  validUpdateDataFact(): boolean {
    return this.showDatafacturingAdd;
  }

  getDataBillingForm(): any {
    return this.dataBiling.validAndObtainDtaBilling();
  }

  getTaxRegimeId(): string {
    return this.dataBiling.getTaxRegimeId();
  }

  getUseCfdi(): any {
    return this.dataBiling.getUseCFDI();
  }

  navegarAPantallaB() {
    void (
      // Pasar la información de proveniencia a través de la navegación
      this.router.navigate(['/management/billing', { provenienteDeCart: true }])
    );
  }

  navegarAPantallaB2() {
    void (
      // Pasar la información de proveniencia a través de la navegación
      this.router.navigate(['/management/billing-add', { provenienteDeCartData: true }])
    );
  }

  openSnackbar() {
    this.hasBillingAddressEvent.emit(false);
    this.snackBar.open('No cuenta con datos de facturación, favor de agregar una dirección de facturación como favorita.', '', { duration: 10000 });
  }
}
